import { render, staticRenderFns } from "./consignment.vue?vue&type=template&id=3f41e628"
import script from "./consignment.vue?vue&type=script&lang=js"
export * from "./consignment.vue?vue&type=script&lang=js"
import style0 from "./consignment.vue?vue&type=style&index=0&id=3f41e628&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports